export default __webpack_public_path__ + "./images/mito.d3720540.jpg";